export const homeTranslations = {
  en: {
    pageTitle: 'Welcome to Po',
    welcomeHeader: 'Welcome',
    updateHeader: 'App update recommended',
    updateMessage: 'To keep up with improvements and services, update your Po River Guide app now!',
    laterButton: 'Later',
    updateButton: 'Update'
  },
  it: {
    pageTitle: 'Benvenuti a Po',
    welcomeHeader: 'Benvenuti',
    updateHeader: 'Aggiornamento app consigliato',
    updateMessage: 'Per restare al passo con le migliorie e i servizi aggiorna subito l\'app del Portolano del Po!',
    laterButton: 'Più tardi',
    updateButton: 'Aggiorna'
  }
};